var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input-group" },
    [
      !_vm.enableMultiLine
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.url,
                expression: "url"
              }
            ],
            ref: "urlInput",
            staticClass: "form-control code-input",
            class: _vm.customClass,
            attrs: {
              name: _vm.name,
              placeholder: "https://ringba.com",
              autocomplete: "off"
            },
            domProps: { value: _vm.url },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.url = $event.target.value
              }
            }
          })
        : _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.url,
                expression: "url"
              }
            ],
            ref: "urlInput",
            staticClass: "form-control",
            class: _vm.customClass,
            attrs: {
              name: _vm.name,
              placeholder: "https://ringba.com",
              autocomplete: "off",
              rows: "1"
            },
            domProps: { value: _vm.url },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.url = $event.target.value
              }
            }
          }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-btn vertical-top" }, [
        _c("button", {
          directives: [
            { name: "t", rawName: "v-t", value: "TOKEN", expression: "'TOKEN'" }
          ],
          ref: _vm.tokenButtonUrl,
          staticClass: "btn btn-secondary",
          attrs: { id: _vm.tokenButtonUrl, type: "button" },
          on: { click: _vm.toggleMacrosPopover }
        })
      ]),
      _vm._v(" "),
      _c(
        "popover",
        {
          attrs: {
            "custom-class": "breakdown-legend__popover",
            placement: "bottom",
            trigger: "manual",
            target: "#" + _vm.tokenButtonUrl
          },
          on: {
            show: function($event) {
              _vm.tagsPopoverVisible = true
            },
            hide: function($event) {
              _vm.tagsPopoverVisible = false
            }
          },
          model: {
            value: _vm.showMacrosPopover,
            callback: function($$v) {
              _vm.showMacrosPopover = $$v
            },
            expression: "showMacrosPopover"
          }
        },
        [
          _c(
            "template",
            { slot: "popover" },
            [
              _c("MacroSelectionPopover", {
                attrs: {
                  "focus-dropdown": _vm.tagsPopoverVisible,
                  "trigger-element": _vm.$refs[_vm.tokenButtonUrl],
                  macros: _vm.macros
                },
                on: {
                  blur: function($event) {
                    _vm.showMacrosPopover = false
                  },
                  "selected-tag": _vm.onSelectedTag
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }